'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'user-bounty-hunter';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e2bf';
var svgPathData = ['M64 16l0 240c0 3.8 .6 7.5 1.7 10.9-.7-3.3-1-6.8-.7-10.4l7.4-114.3C74 115.6 82.5 91 96 70l0-38c8.8 0 16-7.2 16-16S104.8 0 96 0L80 0C71.2 0 64 7.2 64 16zm49.3 236.6l78.1 15.6c-4.3-44.6-33.1-82-72.8-98.8l-5.4 83.2zM160 472l0 35.2c0 2.6 2.1 4.8 4.8 4.8l118.4 0c2.6 0 4.8-2.2 4.8-4.8l0-35.2c0-5-2.4-9.8-6.4-12.8l-48-36c-5.7-4.3-13.5-4.3-19.2 0l-48 36c-4 3-6.4 7.8-6.4 12.8zm96.6-203.8l78.1-15.6-5.4-83.2c-39.6 16.8-68.4 54.2-72.8 98.8z', 'M224 0C143.9 0 77.5 62.2 72.3 142.2L65 256.5c-1.3 20 12.4 37.9 32.1 41.8l100.8 20.2c5.2 1 10.4 1.6 15.7 1.6l20.9 0c5.3 0 10.5-.5 15.7-1.6L351 298.3c19.7-3.9 33.4-21.8 32.1-41.8l-7.4-114.3C370.5 62.2 304.1 0 224 0zM125 120c13.6-42 52.9-72 99-72s85.4 30 99 72L125 120zm-5.5 36.4l80.5 15.1 0 98.4-86.7-17.3 6.2-96.2zm215.2 96.2l-86.7 17.3 0-98.4 80.5-15.1 6.2 96.2zM16 489.1C16 413.4 77.4 352 153.1 352l141.7 0c75.7 0 137.1 61.4 137.1 137.1 0 12.6-10.2 22.9-22.9 22.9l-121.1 0 0-40c0-5-2.4-9.8-6.4-12.8l-48-36c-5.7-4.3-13.5-4.3-19.2 0l-48 36c-4 3-6.4 7.8-6.4 12.8l0 40-121.1 0C26.2 512 16 501.8 16 489.1z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserBountyHunter = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;